import { CIcon } from '~/icons/types'

export const ciWheelLoaders: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M19.927 8.25H21.1a1.572 1.572 0 0 0-1.059-1.022l-8.435-2.953-.033-.01a1.977 1.977 0 0 0-1.068 0h-.01L1.149 7.223A1.579 1.579 0 0 0 .084 8.25h19.843ZM8.38 19.809a2.14 2.14 0 0 0 2.129-1.922H6.253a2.144 2.144 0 0 0 2.128 1.922Zm5.22 0a2.14 2.14 0 0 0 2.128-1.922h-4.253a2.141 2.141 0 0 0 2.125 1.922Z'
    },
    {
      d:
        'M23.51 16.26h-.52v-.32a.5.5 0 0 0-.99 0v.32h-.82V9.23H0v6.47a1.543 1.543 0 0 0 1.55 1.54H22v1.19a.49.49 0 0 0 .98 0v-1.19h.52a.492.492 0 0 0 .46-.673.49.49 0 0 0-.45-.306ZM7.36 13.71a.783.783 0 0 1-.78.79h-3.2a.792.792 0 0 1-.79-.79v-2.36a.783.783 0 0 1 .79-.78h3.2a.78.78 0 0 1 .78.78v2.36Zm5.23 2.55H9.5V11a.49.49 0 0 1 .49-.49h2.11a.49.49 0 0 1 .49.49v5.26Zm6.31-2.55a.783.783 0 0 1-.78.79h-2.73a.782.782 0 0 1-.78-.79v-2.36a.781.781 0 0 1 .78-.78h2.73a.781.781 0 0 1 .78.78v2.36Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'wheel-loaders',
  type: 'solid'
}
